/** 页面数据详情控件 */
import './index.scss'
import React from 'react'
import { Modal, Button } from 'antd';
import moment from 'moment';
import HTMLEcharts from './HTMLEcharts'
import DOMEcharts from './DOMEcharts'
import ComResource from './ComResource'

class PerformanceDetails extends React.Component {
  state = {
    btnSelected: [],
    resourceList: []
  };
  // 显示 按钮
  getBtnGroup = (arr) => {
    return (arr.map(item => {
      return <Button
        key={item} onClick={() => this.setBtnSelected(item)}
        type={this.state.btnSelected.includes(item) ? 'primary' : 'default'}>{item === 'xmlhttprequest' ? 'XHR' : item}</Button>
      })
    )
  };
  // 选中显示项
  setBtnSelected = (item) => {
    const {btnSelected} = this.state;
    const arr = JSON.parse(JSON.stringify(btnSelected));
    let index = arr.indexOf(item);
    if (index === -1) {
      arr.push(item);
    } else {
      arr.splice(index, 1);
    }
    const {resourceList} = this.props.rowData;
    let resourceArr = [];
    resourceList.forEach(item => {
      if (arr.includes(item.resourceType)) {
        resourceArr.push(item)
      }
    });
    this.setState({
      btnSelected: arr,
      resourceList: resourceArr
    });
  };
  // 初始化数据
  initData() {
    const {rowData} = this.props;
    this.setState({
      btnSelected: rowData.resourceTypeList,
      resourceList: rowData.resourceList || []
    })
  };
  UNSAFE_componentWillMount() {
    this.initData();
  };
  UNSAFE_componentWillReceiveProps = () => {
    this.initData();
  };
  render() {
    const {visible, rowData} = this.props;
    const {resourceList} = this.state;
    return (
      <Modal
        title={rowData.path}
        centered
        destroyOnClose={true}
        footer={null}
        visible={visible}
        onCancel={() => this.props.onCancel(false)}
        width={1150}>
        <div className='com-modal-body scroll-bar'>
          <ul className='com-top'>
            <li>
              <span>访问时间：</span>{moment(rowData.createTime).format('YYYY-MM-DD HH:mm:ss')}
            </li>
            <li>
              <span>总耗时：</span>{rowData.loadTime} ms
            </li>
            <li className='pad-left-50'>
              <span>DOM构建：</span>{rowData.domCompleteTime} ms
            </li>
            <li>
              <span>资源加载：</span>{rowData.requestTime} ms
            </li>
            <li>
              <span>访问IP：</span>{rowData.ip}
            </li>
            <li>
              <span>浏览器：</span>{rowData.browserType}{rowData.browserVersion}
            </li>
            <li className='pad-left-50'>
              <span>操作系统：</span>{rowData.systemType}
            </li>
          </ul>
          <div className='sec-echarts'>
            <HTMLEcharts echartsData={rowData.htmlList} rowData={rowData} />
            <DOMEcharts echartsData={rowData.domainList} />
          </div>
          <div className='sec-resource'>
            <label className='sec-resource-label'>资源加载时序图</label>
            <div className='btn-group'>
              {this.getBtnGroup(rowData.resourceTypeList)}
            </div>
            <ComResource data={resourceList} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default PerformanceDetails;
